import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import { PieChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import BasicECharts from 'components/common/BasicEChart';
import {
  GridComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
// import { color } from 'd3';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer
]);

const getOptions = (data, radius, total) => {
  const colors = data.map(item => getColor(item.color));
  return {
    color: colors,

    tooltip: {
      padding: [7, 10],
      transitionDuration: 0,
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: {
        fontSize: 10,
        color: getColor('gray-1100')
      },
      borderWidth: 1,
      formatter: params =>
        // `<strong>${params.data.name}:</strong> ${params.percent}%`
        `<strong>${params.data.name}:</strong> ${params.value}`
    },
    series: [
      {
        name: total,
        type: 'pie',
        radius,
        avoidLabelOverlap: false,
        emphasis: {
          scale: false
        },
        itemStyle: {
          borderWidth: 2,
          borderColor: getColor('gray-100')
        },
        label: {
          show: true,
          position: 'center',
          formatter: '{a}',
          fontSize: 23,
          color: getColor('gray-1100')
        },
        data
      }
    ]
  };
};

const OperationsItem = ({ item, index, total, qtd }) => {
  const { name, color, value } = item;  
  const percentage = ((value * 100) / total).toFixed(0);
  return (
    <Flex
      alignItems="center"
      justifyContent="between"
      className={`fw-semi-bold fs--2 ${index == 0 && 'mt-3'}`}
    >
      <p className="mb-1" style={{ fontSize: '0.6rem' }}>
        <FontAwesomeIcon
          icon="circle"
          className={`me-2 text-${color.split('-')[1] || color}`}
        />
        {name} &nbsp;-&nbsp;{value}
      </p>
      {/* <div className="d-xxl-none">{percentage}</div> */}

    </Flex>
  );
};

const Operations = ({ atualizou, data, radius, totalOp, titulo }) => {
  const total = data.reduce((acc, val) => val.value + acc, 0);
  const colorOp = [];
  useEffect(() => {
    if (data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        colorOp.push(getColor(data[index].color));
      }
    }
  }, []);

  return atualizou ? (
    <>
      <Card className="h-md-100">
        <Card.Body>
          <Row className="justify-content-between g-0">
            <Col xs={8} sm={8} lg={6} xxl={6} className="pe-2">
              <h6 className="mt-1">{titulo}</h6>              
              {data.map((item, index) => (
                <OperationsItem
                  item={item}
                  index={index}
                  key={index}
                  total={total}
                />
              ))}
            </Col>
            <Col xs={4} sm={4} lg={6} xxl={6} className="d-flex justify-content-end">
              <div className="ps-0">
                <BasicECharts
                  echarts={echarts}
                  options={getOptions(data, radius, totalOp)}
                  style={{ width: '5rem', height: '5rem', marginTop: '2rem' }}
                />
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  ) : (
    <></>
  );
};

OperationsItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  }),
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  qtd: PropTypes.number.isRequired
};

Operations.propTypes = {
  data: PropTypes.array.isRequired,
  radius: PropTypes.array.isRequired,
  totalOp: PropTypes.array.isRequired,
  atualizou: PropTypes.bool,
  titulo: PropTypes.string.isRequired,
};

export default Operations;
